import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomersBelowMonthlyOrderGoalReport extends Layout {
    checkboxpageBreak: Checkbox;
    excludabletextboxC: ExcludableTextbox;
    excludabletextboxS: ExcludableTextbox;
    sourceCustomersBelowMonthlyOrderGoal: DataSource;
    switchPercentOrNumber: Switch;
    textboxDateRange: Textbox;
    textboxDateType: Textbox;
    textboxDisplayInterval: Textbox;
    textboxGoalNum: Textbox;
    textboxGroupBy: Textbox;
}
